import { post } from '../../../helpers/axios';

const BASE_PATH = '/auth';

export const login = (email, password) => post(`${BASE_PATH}/login`, { email, password });
